import React, { useState, useEffect, useMemo, useRef, createRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { Modal, ModalTitle, ModalBody } from '@vds3/modals';
import { Body, Title } from '@vds3/typography';
import { Button } from '@vds3/buttons';
import { getFiosTv, setTVRecordingSelectionvalue, saveViewSelection, updateCart, setTvHdSetupSelection, updateSerivcesInCartbyBDV, setStoreOldId, setStoreEquipment, setStoreChannel, setStoreSubTitle, setSelectedTVViewingOption, setTvChannelInfo, setTVRecordingSelection } from '../containers/actions';
import { MarginSpacerL } from './styleTag';


const RemoveServiceModalNew = (props) => {

  const ChangeModal = (modal) => {
    props.OpenCloseModal(modal)
  }
  const ConfirmRemoveTVService = () => {
    props.updateCart({ type: "FIOSTV", data: { "PlanSelection": { "OldID": props?.OldID, "NewID": "" } } })
    props.setStoreOldId(undefined)
    props.setStoreEquipment(undefined)
    props.setStoreChannel(undefined)
    props.setStoreSubTitle(undefined)
    props.setSelectedTVViewingOption(undefined)
    props.setTVRecordingSelectionvalue('')
    props.setTvChannelInfo("Local TV")
    props.setTVRecordingSelection("idontwant");
    // props.resetTVSubHeaderCall();
    // props.resetTvAddonsSection();
    props.OpenCloseModal(false)
  }
  const CancelRemoveTVService = (cancel) => {
    props.OpenCloseModal(cancel)
  }
  return (
    <Modal
      ariaLabel=""
      opened={true}
      onOpenedChange={ChangeModal}>
      <div className='removeModalContent'>
        <ModalTitle>
          <Title size="medium" primitive="h2" bold>Are you sure you want to remove this service?</Title>
        </ModalTitle>
        <ModalBody>
          <div>
            <Body size="large">Removing will delete your added TV service choices.</Body>
            <MarginSpacerL/>
            <div className='rdio-Box-tv-new'>
              <Button onClick={() => ConfirmRemoveTVService()} width="100%" >Remove TV service</Button>
              <Button use="secondary" width="100%"
                onClick={() => CancelRemoveTVService(false)} >Do not remove</Button>
            </div>
            .                   </div>
        </ModalBody>
      </div>
    </Modal>
  )
}
const mapStateToProps = (state, props) => {
  return {

  }
}
const mapDispatchToProps = (dispatch) => ({
  updateCart: (data) => dispatch(updateCart(data)),
  setStoreOldId: (data)=>dispatch(setStoreOldId(data)),
  setStoreEquipment: (data)=>dispatch(setStoreEquipment(data)),
  setStoreChannel: (data)=>dispatch(setStoreChannel(data)),
  setStoreSubTitle: (data)=>dispatch(setStoreSubTitle(data)),
  setSelectedTVViewingOption: (data)=>dispatch(setSelectedTVViewingOption(data)),
  setTvChannelInfo: (data)=>dispatch(setTvChannelInfo(data)),
  setTVRecordingSelectionvalue: (data)=>dispatch(setTVRecordingSelectionvalue(data)),
  setTVRecordingSelection: (data)=>dispatch(setTVRecordingSelection(data))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RemoveServiceModalNew));